module.exports = __webpack_public_path__ + "static/media/MHRP09N0014.30614409.svg";